import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-filter",
  "use": "various-filter-usage",
  "viewBox": "0 0 29 97",
  "content": "<symbol viewBox=\"0 0 29 97\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-filter\"><path d=\"M8 53h6v14H0V53h6V29H0l7-14 7 14H8v24zM0 68h14v14H0V68zm0 15h14v14H0V83zm15-30h14v14H15V53zM2 55v10h10V55H2zm13 13h14v14H15V68zm0 15h14v14H15V83zM0 0h14v14H0V0z\" fill=\"#e3000f\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol